import { useDevices } from '@/utils/devices';

type Config<V> = {
  desktop: V;
  tablet?: V;
  phone?: V;
};

export const useResponsiveProp = <V extends string | number | Record<string, unknown>>(config: Config<V>): V => {
  const { device } = useDevices();

  return config[device] ?? config.desktop;
};
